import React from 'react';
import type { FC } from 'react';

interface LogoProps {
  [key: string]: any;
}

const Logo: FC<LogoProps> = (props) => {
  return (
    <img
      alt="Arupo Legaltech Innovation Hub Logo"
      title="Arupo Legaltech Innovation Hub Logo"
      src="/static/logo.svg"
      {...props}
    />
  );
}

export default Logo;
